import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "../Store/Hooks";
import { fetchHealthScoreThresholds } from "../Store/Reducers/VendorAdminSlice";
import {
  DEFAULT_HEALTH_SCORE_THRESHOLDS,
  type AccountHealthThresholds,
  type BusinessHealthThresholds,
  type HealthScoreThresholds,
} from "../Utils/HealthThresholds";

export type UseHealthScoreThresholdsResult = {
  /** Normalized vendor bands (defaults until first fetch settles). */
  thresholds: HealthScoreThresholds;
  businessHealth: BusinessHealthThresholds;
  accountHealth: AccountHealthThresholds;
  loading: boolean;
  fetched: boolean;
};

/**
 * Shared access to vendor_config.health_score_thresholds.
 * Fetches once per session (thunk skips when already loading/fetched).
 */
export function useHealthScoreThresholds(): UseHealthScoreThresholdsResult {
  const dispatch = useAppDispatch();
  const thresholds =
    useAppSelector(state => state.vendorAdmin.healthScoreThresholds) ||
    DEFAULT_HEALTH_SCORE_THRESHOLDS;
  const loading = useAppSelector(
    state => state.vendorAdmin.healthScoreThresholdsLoading
  );
  const fetched = useAppSelector(
    state => state.vendorAdmin.healthScoreThresholdsFetched
  );

  useEffect(() => {
    void dispatch(fetchHealthScoreThresholds());
  }, [dispatch]);

  return {
    thresholds,
    businessHealth: thresholds.business_health,
    accountHealth: thresholds.account_health,
    loading,
    fetched,
  };
}
